export function validateColor(color: string) {
  if (!color.startsWith("#")) {
    return false;
  }
  if (color.length !== 7) {
    return false;
  }
  const colorHex = color.substring(1).toUpperCase();
  if (isNaN(Number(`0x${colorHex}`))) {
    return false;
  }
  return true;
}

export function isNumber(text: string) {
  if (!text) {
    return false;
  }
  if (isNaN(Number(text))) {
    return false;
  }
  return true;
}

export function validateUrl(url: string): string {
  const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
  if (!urlRegex.test(url)) {
    return "Invalid URL";
  }
}
